import ApiService from "../ApiService";
import { StorageService } from "../StorageService";

const kardexService = {
  getMedicineKardex(page, rowsPerPage, search, date, date2, searchType) {
    return ApiService.customRequest({
      url: `${process.env.VUE_APP_ROOT_API}/add-kardex/search_report?page=${page}&perPage=${rowsPerPage}&searchString=${search}&dateAfter=${date}&dateBefore=${date2}&searchType=${searchType}`,
      method: "post",
    });
  },
  getKardex(page, rowsPerPage, search, searchType) {
    return ApiService.customRequest({
      url: `${process.env.VUE_APP_ROOT_API}/kardex/search_report?page=${page}&perPage=${rowsPerPage}&searchString=${search}&searchType=${searchType}`,
      method: "post",
    });
  },
  bulkUpdate_kardex(data) {
    return ApiService.post("/add-kardex/bulkUpdate", data);
  },
  delivered_medicine(data) {
    return ApiService.post("/kardex/delivered_medicine", data);
  },

  getKardexOutReasons() {
    return ApiService.get("movement-type?type=SALIDA");
  },

  getKardexBatchWithAmounts(providerId, branchId, medicineId) {
    return ApiService.get(
      `kardex/amounts_medication?provider=${providerId}&branch=${branchId}&medicine=${medicineId}&page=1&perPage=99999`
    );
  },
  getKardexOutData(page, rowsPerPage, search, date, date2, searchType) {
    return ApiService.customRequest({
      url: `${process.env.VUE_APP_ROOT_API}/out-kardex/search_report?page=${page}&perPage=${rowsPerPage}&searchString=${search}&dateAfter=${date}&dateBefore=${date2}&searchType=${searchType}`,
      method: "post",
    });
  },

  getKarderTransferData(page, rowsPerPage, search, date, date2, searchType) {
    return ApiService.customRequest({
      url: `${process.env.VUE_APP_ROOT_API}/transfer-kardex/search_report?page=${page}&perPage=${rowsPerPage}&searchString=${search}&dateAfter=${date}&dateBefore=${date2}&searchType=${searchType}`,
      method: "post",
    });
  },
  createOutKardex(data) {
    return ApiService.customRequest({
      url: `${process.env.VUE_APP_ROOT_API}/out-kardex/save_objet/`,
      method: "post",
      data,
    });
  },
  createTransferKardex(data) {
    return ApiService.customRequest({
      url: `${process.env.VUE_APP_ROOT_API}/transfer-kardex/save_objet/`,
      method: "post",
      data,
    });
  },
  async bulkUpdate_outKardex(data) {
    return await ApiService.post("/out-kardex/bulkUpdate", data);
  },
};

export default kardexService;
